export default __webpack_public_path__ + "static/media/YAS0190.34I-41203_-24570_0.0bdba19e.jpg";